import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { DragScrollComponent } from 'ngx-drag-scroll';
import { merge, Subject } from 'rxjs';
import { delay, map, takeUntil } from 'rxjs/operators';

import { InstallationsStore } from '@store';

@Component({
  selector: 'app-main-devices-list-large',
  templateUrl: './main-devices-list-large.component.html',
  styleUrls: ['./main-devices-list-large.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainDevicesListLargeComponent implements AfterViewInit, OnDestroy {
  @Input() installationId: number;
  @ViewChild('dragScroll', { read: DragScrollComponent }) dragScroll: DragScrollComponent;

  isDragging: boolean;
  canNotMoveLeft = true;
  canNotMoveRight: boolean;

  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(public installationsStore: InstallationsStore, private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.observeDragScrollEvents();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  moveContainer(direction: 'left' | 'right'): void {
    if (direction === 'left') {
      this.dragScroll.moveLeft();
    }
    if (direction === 'right') {
      this.dragScroll.moveRight();
    }
  }

  private observeDragScrollEvents(): void {
    merge(
      this.dragScroll.dragStart.pipe(map(() => true)),
      this.dragScroll.dragEnd.pipe(
        map(() => false),
        // Due to tile's click event which would fire afterwards
        delay(10)
      )
    )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        this.isDragging = res;
        this.cdRef.detectChanges();
      });

    this.dragScroll.reachesLeftBound.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if (res !== this.canNotMoveLeft) {
        this.canNotMoveLeft = res;
        this.cdRef.detectChanges();
      }
    });

    this.dragScroll.reachesRightBound.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res) => {
      if (res !== this.canNotMoveRight) {
        this.canNotMoveRight = res;
        this.cdRef.detectChanges();
      }
    });
  }
}
